import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "scrollListContainer" }
const _hoisted_4 = { class: "scrollBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_answers_viewer = _resolveComponent("form-answers-viewer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _createVNode(_component_localized_text, {
          localizedKey: "Articoli",
          text: "Articoli"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart.offers, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "scrollListItem",
              key: item.offer.identifier
            }, _toDisplayString(item.offer.name) + " x " + _toDisplayString(item.quantity), 1))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_form_answers_viewer, {
      answers: _ctx.cart.formAnswers
    }, null, 8, ["answers"])
  ]))
}